
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.667 7.333H3.333V12h1.334V7.333zm4 0H7.333V12h1.334V7.333zm5.666 6H1.667v1.334h12.666v-1.334zm-1.666-6h-1.334V12h1.334V7.333zM8 2.84l3.473 1.827H4.527L8 2.84zm0-1.507L1.667 4.667V6h12.666V4.667L8 1.333z","fill":"currentColor"}})])
          )
        }
      }
    